'use client';

import * as React from 'react';

import type { Settings } from '@/types/settings';
import { applyDefaultSettings } from '@/lib/settings/apply-default-settings';

export interface SettingsContextValue {
  settings: Settings;
  setSettings: (settings: Settings) => void;
}

export const SettingsContext = React.createContext<SettingsContextValue>({
  settings: applyDefaultSettings({}),
  setSettings: () => {
    // noop
  },
});

export interface SettingsProviderProps {
  children: React.ReactNode;
  settings: Settings;
}

export function SettingsProvider({ children, settings: initialSettings }: SettingsProviderProps): React.JSX.Element {
  const [state, setState] = React.useState<Settings>(initialSettings);

  React.useEffect(() => {
    setState(initialSettings);
  }, [initialSettings]);

  //Exchnage rates should not be stored in redux: use useExchangeRates hook

  // React.useEffect(() => {
  //   const getExchangeRates = async (): Promise<void> => {
  //     try {
  //       const res = await fetch(`/api/rates`, {
  //         method: 'GET',
  //         cache: 'no-store',
  //       });

  //       if (res.ok) {
  //         const resData: ServiceResponse<ExchangeRatesResponse | null> | undefined = await res.json();

  //         if (!resData?.data) return;

  //         const filteredRates = { ...resData.data };

  //         if (filteredRates.exchangeRates['IRR']) {
  //           delete filteredRates.exchangeRates['IRR'];
  //         }

  //         // Dispatch the filtered data
  //         dispatch(addCurrencies(filteredRates));
  //       }
  //     } catch (e) {
  //       // console.error(e)
  //       return undefined;
  //     }
  //   };

  //   void getExchangeRates();

  //   const intervalId = setInterval(() => {
  //     void getExchangeRates();
  //   }, 60000);

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  return (
    <SettingsContext.Provider
      value={{
        settings: state,
        setSettings: (newSettings: Settings) => {
          setState(newSettings);
        },
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export const SettingsConsumer = SettingsContext.Consumer;
